module.exports = __webpack_public_path__ + "static/media/impact.e248449e.png";